import {
	STATUS_TRANSFERS_INCOMING,
	STATUS_TRANSFERS_OUTGOING,
	TAB_TRANSFERS_INCOMING,
	TAB_TRANSFERS_OUTGOING,
	TRANSFERS_TYPE,
	TRANSFERS_TYPE_FILE
} from 'components/pages/transfers/base/enumsTransfers';
import { CONST } from 'constants/enums';
import { template } from 'utils/helper';

export const url_transfers = {
	transfer_file: template`transfers/files/${'slug'}/`,
	object: template`transfers/${'slug'}/`,
	delete: 'transfers/delete/',
	list: 'transfers/',
	change_status: 'transfers/change-status/',
	import: 'transfers/import/',
	export: 'transfers/export/',
	create: 'transfers/create/',
	create_all: template`transfers/create/${'slugAgreement'}/`,
	transfer_clear_invoice: template`transfers/${'slugTransfer'}/clear/`,
	transfer_sub_transfer: template`transfers/${'slugTransfer'}/subtransfer/${'slugSubTransfer'}/`,
	realized_outside_system: template`transfers/${'slug'}/realize-outside-system/`,
	files: 'transfers/files/'
};

// /transfers/network-service/ na wejściu bierze {
// 	"transfers": [self.transfer.slug],
// 	"status": PaymentAuthorization.SIGNATURE_AND_SEND,
// }
const transfers = service => ({
	signAndSend: (slugTransfers) => service.put('/transfers/network-service/', { transfers: slugTransfers, status: 30 }),
	downloadTransferFile: ({ slug }) => service.get(url_transfers.transfer_file({ slug }), {
		headers: {
			'Content-Type': 'multipart/form-data'
		},
		responseType: 'arraybuffer'
	}),
	updateTransfer: ({ slug, values }) => service.patch(url_transfers.object({ slug }), values),
	deleteTransfers: ({ ids }) => service.delete(url_transfers.delete, { data: { transfers: ids } }),
	realizedOutsideSystem: ({ slug }) => service.put(url_transfers.realized_outside_system({ slug }), { realizedOutsideSystem: true }),
	settle: ({ vatValue, ...otherValues }, { slugTransfer, isVatChecked }) => {
		const valuesToSend = Object.assign(otherValues,
			isVatChecked && { vatValue },
		);
		return service.post(url_transfers.transfer_clear_invoice({ slugTransfer }), valuesToSend);
	},
	deleteSubTransfer: ({ slugTransfer, slugSubTransfer }) => service.delete(url_transfers.transfer_sub_transfer({ slugTransfer, slugSubTransfer })),
	changeStatus: ({ ids, status }) => service.put(url_transfers.change_status, {
		transfers: ids,
		status
	}),
	importTransfer: ({ dataUri, values }) => {
		const formData = new FormData();

		if (values) {
			for (const [key, value] of Object.entries(values)) {
				formData.append(key, value);
			}
		}
		formData.append('file', dataUri, dataUri.name);

		return service.put(url_transfers.import, formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
			}
		});
	},
	exportTransfers: ({ ids, slugAgreement }) => {
		const params = Object.assign({},
			ids?.length && { transfers: ids },
			slugAgreement && { agreement: slugAgreement },
		);

		return service.post(url_transfers.export, params, {
			responseType: 'blob'
		});
	},
	generateTransfers: ({ ids, slugAgreement }) => {
		const params = Object.assign({},
			ids?.length && { orders: ids },
			slugAgreement && { agreement: slugAgreement },
		);
		return service.post(url_transfers.create, params);
	},
	generateTransfersByAgreement: ({ slugAgreement }) => service.post(url_transfers.create_all({ slugAgreement })),
	getTransfer: ({ slug }) => service.get(url_transfers.object({ slug })),
	getTransfers: ({ agreementSlug, page, rowsPerPage, sortParameter, isOrderByAsc, searchParameter, currentTab, type }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;
		const incomingTab = currentTab || TAB_TRANSFERS_INCOMING.IMPORTED;
		const outgoingTab = currentTab || TAB_TRANSFERS_OUTGOING.BUFFER;

		const defaultOrderIncoming = {
			[TAB_TRANSFERS_INCOMING.IMPORTED]: { o: '-importedDate' },
			[TAB_TRANSFERS_INCOMING.WAITING]: { o: '-importedDate' },
			[TAB_TRANSFERS_INCOMING.IN_SETTLEMENT]: { o: '-clearedDate' },
			[TAB_TRANSFERS_INCOMING.SETTLED]: { o: '-clearedDate' },
			[TAB_TRANSFERS_INCOMING.OUTSIDE_FACTORING]: { o: '-modifiedDate' },
		};

		const defaultOrderOutgoing = {
			[TAB_TRANSFERS_OUTGOING.TO_SIGN]: { o: '-createdDate' },
			[TAB_TRANSFERS_OUTGOING.SIGNED]: { o: '-modifiedDate' },
			[TAB_TRANSFERS_OUTGOING.BUFFER]: { o: '-createdDate' },
			[TAB_TRANSFERS_OUTGOING.SENT]: { o: '-exportedDate' },
			[TAB_TRANSFERS_OUTGOING.REALIZED]: { o: '-modifiedDate' },
			[TAB_TRANSFERS_OUTGOING.UNREALIZED]: { o: '-modifiedDate' },
			[TAB_TRANSFERS_OUTGOING.UNRELATED]: { o: '-modifiedDate' },
			[TAB_TRANSFERS_OUTGOING.PROCESSING]: { o: '-modifiedDate' },
		};

		const defaultOrderObj = TRANSFERS_TYPE.INCOMING === type 
			? defaultOrderIncoming[incomingTab] 
			: defaultOrderOutgoing[outgoingTab];

		const pagination = Object.assign({},
			order ? { o: order } : defaultOrderObj,
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		const otherParams = Object.assign({},
			searchParameter && { q: searchParameter },
			type && { type },
			agreementSlug && (agreementSlug !== CONST.ALL_SLUG_ROUTE) && { agreement: agreementSlug },
		);

		const filtersIncoming = {
			[TAB_TRANSFERS_INCOMING.IMPORTED]: { ...pagination, status: STATUS_TRANSFERS_INCOMING.IMPORTED },
			[TAB_TRANSFERS_INCOMING.WAITING]: { ...pagination, status: STATUS_TRANSFERS_INCOMING.WAITING },
			[TAB_TRANSFERS_INCOMING.IN_SETTLEMENT]: { ...pagination, status: STATUS_TRANSFERS_INCOMING.IN_SETTLEMENT },
			[TAB_TRANSFERS_INCOMING.SETTLED]: { ...pagination, status: STATUS_TRANSFERS_INCOMING.SETTLED },
			[TAB_TRANSFERS_INCOMING.OUTSIDE_FACTORING]: { ...pagination, status: STATUS_TRANSFERS_INCOMING.OUTSIDE_FACTORING }
		};

		const filtersOutgoing = {
			[TAB_TRANSFERS_OUTGOING.TO_SIGN]: { ...pagination, signed: 0 },
			[TAB_TRANSFERS_OUTGOING.SIGNED]: { ...pagination, signed: 1 },
			[TAB_TRANSFERS_OUTGOING.BUFFER]: { ...pagination, status: STATUS_TRANSFERS_OUTGOING.BUFFER },
			[TAB_TRANSFERS_OUTGOING.SENT]: { ...pagination, status: STATUS_TRANSFERS_OUTGOING.SENT },
			[TAB_TRANSFERS_OUTGOING.REALIZED]: { ...pagination, status: STATUS_TRANSFERS_OUTGOING.REALIZED },
			[TAB_TRANSFERS_OUTGOING.UNREALIZED]: { ...pagination, status: STATUS_TRANSFERS_OUTGOING.UNREALIZED },
			[TAB_TRANSFERS_OUTGOING.UNRELATED]: { ...pagination, status: STATUS_TRANSFERS_OUTGOING.NOT_RELATED },
			[TAB_TRANSFERS_OUTGOING.PROCESSING]: { ...pagination, isProcessingByNetworkService: 1 }
		};

		const filters = {
			[TRANSFERS_TYPE.INCOMING]: filtersIncoming[incomingTab],
			[TRANSFERS_TYPE.OUTGOING]: filtersOutgoing[outgoingTab]
		};

		return service.get(url_transfers.list, {
			params: {
				...filters[type],
				...otherParams,
			}
		});
	},
	getFiles: ({ agreementSlug, page, rowsPerPage, sortParameter, isOrderByAsc, searchParameter, type }) => {
		const order = sortParameter && `${isOrderByAsc ? '' : '-'}${sortParameter}`;

		const defaultOrder = {
			[TRANSFERS_TYPE_FILE.IMPORT]: { o: '-createdDate' },
			[TRANSFERS_TYPE_FILE.EXPORT]: { o: '-createdDate' },
		};

		const pagination = Object.assign({},
			order ? { o: order } : defaultOrder[type],
			rowsPerPage && { pageSize: rowsPerPage },
			page && { page: page + 1 }
		);

		const otherParams = Object.assign({},
			searchParameter && { q: searchParameter },
			type && { type },
			agreementSlug && (agreementSlug !== CONST.ALL_SLUG_ROUTE) && { agreement: agreementSlug },
		);

		return service.get(url_transfers.files, {
			params: {
				...pagination,
				...otherParams,
			}
		});
	}
});

export default transfers;
